import { canUseLocalStorage } from './canuse';
import { setAmplitudeUserProperty } from './analytics';

const rint = (max = 1) => Math.round(Math.random() * max);

const executeExperiment = (experimentID, options, persistent) => {
  const generatedIndex = rint(options.length - 1);

  if (persistent) {
    if (canUseLocalStorage()) {
      const cachedValue = localStorage.getItem(experimentID);
      let experimentValue = cachedValue && JSON.parse(localStorage.getItem(experimentID));
      if (!experimentValue) {
        experimentValue = options[generatedIndex];
        localStorage.setItem(experimentID, JSON.stringify(experimentValue));
        setAmplitudeUserProperty(experimentID, { value: experimentValue });
      }
      return experimentValue;
    }
  } else {
    return options[generatedIndex];
  }
};

const experiments = {
  'element-arena-pitch-text-exp-1': {
    persist: true,
    options: [
      'Element Arena: MOBA Fighter Battle Royale',
      'Fast paced battle royale fighter -- Play now!',
      'Element Arena in Early Access now!'
    ]
  },
  'element-arena-btn-text-exp-1': {
    persist: true,
    options: ['Play Now!', 'Install Now!']
  },
  'nav-bar-color-exp-1': {
    persist: true,
    options: [
      { background: `#151515`, foreground: `white` },
      { background: `#eee`, foreground: `black` }
    ]
  }
};

const experiment = experimentID => {
  const experimentConfig = experiments[experimentID];
  if (!experimentConfig) return;

  const { options, persist } = experimentConfig;
  const experimentValue = executeExperiment(experimentID, options, persist);
  return experimentValue;
};

export default experiment;
